import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, TwitterIcon, LinkedinIcon, MessageSquareIcon, FeatherIcon, FacebookIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="navy-bg text-white py-12 w-full" data-id="element-106">
      <div className="container mx-auto px-4" data-id="element-107">
        <div className="flex justify-center mb-8" data-id="element-108">
          <div className="flex flex-col items-center" data-id="element-109">
            <FeatherIcon size={20} className="text-white mb-2" data-id="element-110" />
            <div className="text-center" data-id="element-111">
              <span className="text-lg font-bold accent-color" style={{
              fontFamily: 'var(--font-serif)'
            }} data-id="element-112">
                Muthamia Content Agency
              </span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-113">
          <div data-id="element-114">
            <h3 className="text-xl font-bold mb-4 accent-color" data-id="element-115">
              Muthamia Content Agency
            </h3>
            <p className="text-gray-300 mb-6" data-id="element-116">
              Corporate brand strategy meets native storytelling.
            </p>
            <div className="flex space-x-4" data-id="element-117">
              <a href="https://www.facebook.com/share/16nuc72ant/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 gold-gradient rounded-full flex items-center justify-center text-white hover:scale-110 transition-all" aria-label="Facebook" data-id="element-118">
                <FacebookIcon size={20} data-id="element-119" />
              </a>
              <a href="https://www.linkedin.com/in/kibakimuthamia-seocontent?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer" className="w-10 h-10 gold-gradient rounded-full flex items-center justify-center text-white hover:scale-110 transition-all" aria-label="LinkedIn" data-id="element-120">
                <LinkedinIcon size={20} data-id="element-121" />
              </a>
              <a href="https://www.tiktok.com/@storyteller_kenya?_t=ZM-8yvqvJD71Ij&_r=1" target="_blank" rel="noopener noreferrer" className="w-10 h-10 gold-gradient rounded-full flex items-center justify-center text-white hover:scale-110 transition-all" aria-label="TikTok" data-id="element-122">
                {/* Custom TikTok icon since lucide doesn't have one */}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-123">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-124"></path>
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-125">
            <h3 className="text-xl font-bold mb-4 accent-color" data-id="element-126">Quick Links</h3>
            <ul className="space-y-2" data-id="element-127">
              <li data-id="element-128">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-129">
                  Home
                </Link>
              </li>
              <li data-id="element-130">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-131">
                  Services
                </Link>
              </li>
              <li data-id="element-132">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-133">
                  About Us
                </Link>
              </li>
              <li data-id="element-134">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-135">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-136">
            <h3 className="text-xl font-bold mb-4 accent-color" data-id="element-137">Contact Us</h3>
            <div className="flex items-center space-x-2 text-gray-300 mb-2" data-id="element-138">
              <MailIcon size={16} data-id="element-139" />
              <a href="mailto:info@muthamiacontent.com" className="hover:text-white transition-colors" data-id="element-140">
                info@muthamiacontent.com
              </a>
            </div>
            <p className="text-gray-300 mb-4" data-id="element-141">Nairobi, Kenya</p>
            <Link to="/contact" className="flex items-center space-x-2 text-white gold-gradient hover:bg-opacity-90 px-4 py-2 rounded-md w-fit transition-colors" data-id="element-142">
              <MessageSquareIcon size={18} data-id="element-143" />
              <span data-id="element-144">Get in Touch</span>
            </Link>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400" data-id="element-145">
          <p data-id="element-146">
            &copy; {new Date().getFullYear()} Muthamia Content Agency. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}